import { FieldSchema } from "../../../Schema";

export const costCenter: FieldSchema = {
  grid: {
    displayed: true,
    order: 39,
    sortable: false,
  },
  name: "costCenter",
  display: {
    displayed: true,
  },
  form: { label: "Cost center" },
};
